var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ 'exn_cursor', { 'exn_cursor_hover': _vm.hover }, {'exn_cursor_hide': _vm.hideCursor}]},[_c('div',{ref:"point",staticClass:"exn_cursor_point",style:(_vm.cursorPoint)})])}
var staticRenderFns = []

export { render, staticRenderFns }